export default __webpack_public_path__ + "static/media/entrance_9_1.5dcdb3ae.png";